export const EMAIL_SENDER_API_END_POINT = {
  list: "notifications/selfserve/email/senders/list",
  add: "notifications/selfserve/email/senders/add",
  update: "notifications/selfserve/email/senders/update",
  delete: "notifications/selfserve/email/senders/delete",
  sync: "notifications/selfserve/email/records/sync",
};
